<template>
  <div class="radio-button-box flex f-column mb-children-1" v-validate="errors">
    <div
      class="simple-radio"
      v-for="(option, index) in options"
      :key="index + 1"
      :class="{'simple-radio-checked': value && option.name$ === value.name$}"
      @click.prevent="$emit('input', option)"
    >
      {{option.label}}
    </div>
    <div class="validation-output">
      <slot name="validations"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircleRadioBox',
  props: [
    'value',
    'options',
    'errors',
  ],
};
</script>
